/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationLogoResult } from '../../models/organization-logo-result';

export interface AdminFhirIdOrganizationLogoGet$Params {
  fhirId: string;
}

export function adminFhirIdOrganizationLogoGet(http: HttpClient, rootUrl: string, params: AdminFhirIdOrganizationLogoGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<OrganizationLogoResult>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdOrganizationLogoGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<OrganizationLogoResult>;
    })
  );
}

adminFhirIdOrganizationLogoGet.PATH = '/Admin/{fhirId}/OrganizationLogo';
